import React, { useEffect, useState } from 'react';
import { showMaintenancePopup } from '../../../Utils/function';
import { API_URL } from '../../../config';
import { getRequest } from '../../../Utils/AppApi';

function Header({ scrollToSection, refs }) {
    const [appInfo, setAppInfo] = useState(null);
    const [isInMaintenance, setIsInMaintenance] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const handleLinkClick = (event, ref) => {
        event.preventDefault();
        if (isInMaintenance) {
            showMaintenancePopup();
        } else if (ref) {
            scrollToSection(ref);
        }
        setIsMobileMenuOpen(false);
    };

    useEffect(() => {
        getAppInfo();
        const handleScroll = () => setIsScrolled(window.scrollY > 50);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const getAppInfo = async () => {
        try {
            const data = await getRequest(`${API_URL}/appinfo`);
            if (data) {
                setAppInfo(data);
                setIsInMaintenance(data.isMaintenance);
            }
        } catch (error) {
            console.error('Error fetching app info:', error);
        }
    };

    return (
        <header style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            zIndex: 1000,
            // background: isScrolled 
            //     ? 'rgba(255, 255, 255, 0.98)' 
            //     : 'rgba(255, 255, 255, 0.85)',
            background: 'linear-gradient(160deg, #FFFBEB 0%, #FFF8F5 25%, #FFFBEB 50%, #F8F9FF 75%, #FFFBEB 100%)',

            backdropFilter: 'blur(20px) saturate(180%)',
            WebkitBackdropFilter: 'blur(20px) saturate(180%)',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            padding: isScrolled ? '6px 0' : '10px 0',
            boxShadow: isScrolled ? '0 1px 20px rgba(0,0,0,0.06)' : 'none'
        }}>
            <nav className="container" style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                maxWidth: '1200px',
                margin: '0 auto',
                padding: '0 20px'
            }}>
                {/* Logo */}
                <a href="/" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }} style={{ flexShrink: 0 }}>
                    <img
                        src="img/logos/logo.png"
                        className="main-logo"
                        alt="SR PAY"
                        style={{
                            height: isScrolled ? '50px' : '60px',
                            transition: 'all 0.3s ease'
                        }}
                    />
                </a>

                {/* Desktop Navigation */}
                <ul style={{
                    listStyle: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px',
                    margin: 0,
                    padding: 0
                }} className="desktop-nav">
                    {[
                        { label: 'Home', icon: '🏠', ref: null, action: () => window.scrollTo({ top: 0, behavior: 'smooth' }) },
                        { label: 'About', icon: 'ℹ️', ref: refs.aboutRef },
                        { label: 'Services', icon: '⚡', ref: refs.servicesRef },
                        { label: 'Download', icon: '📲', ref: refs.downloadRef },
                        { label: 'Join Us', icon: '🤝', ref: refs.joinRef },
                        { label: 'Contact', icon: '📞', ref: refs.contactRef }
                    ].map((item, i) => (
                        <li key={i}>
                            <a
                                href={`#${item.label.toLowerCase().replace(' ', '-')}`}
                                onClick={(e) => item.action ? item.action() : handleLinkClick(e, item.ref)}
                                style={{
                                    color: '#4A4A6A',
                                    textDecoration: 'none',
                                    padding: '10px 16px',
                                    borderRadius: '50px',
                                    transition: 'all 0.3s ease',
                                    fontWeight: 500,
                                    fontSize: '14px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                    whiteSpace: 'nowrap'
                                }}
                                onMouseOver={(e) => {
                                    e.target.style.color = '#C9262C';
                                    e.target.style.background = '#FFF5F5';
                                }}
                                onMouseOut={(e) => {
                                    e.target.style.color = '#4A4A6A';
                                    e.target.style.background = 'transparent';
                                }}
                            >
                                <span style={{ fontSize: '15px' }}>{item.icon}</span>
                                {item.label}
                            </a>
                        </li>
                    ))}

                    {/* Premium Login Button */}
                    <li>
                        <a
                            href="/login"
                            target="_blank"
                            style={{
                                background: 'linear-gradient(135deg, #FFDD09 0%, #FFA500 50%, #FF8C00 100%)',
                                color: '#fff',
                                textDecoration: 'none',
                                padding: '11px 26px',
                                borderRadius: '50px',
                                transition: 'all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
                                fontWeight: 700,
                                fontSize: '14px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                                boxShadow: '0 4px 15px rgba(255,140,0,0.3), 0 0 0 3px rgba(255,221,9,0.1)',
                                letterSpacing: '0.3px',
                                whiteSpace: 'nowrap'
                            }}
                            onMouseOver={(e) => {
                                e.target.style.transform = 'translateY(-2px) scale(1.05)';
                                e.target.style.boxShadow = '0 8px 25px rgba(255,140,0,0.5), 0 0 0 6px rgba(255,221,9,0.15)';
                                e.target.style.background = 'linear-gradient(135deg, #FFE44D 0%, #FFB833 50%, #FFA500 100%)';
                            }}
                            onMouseOut={(e) => {
                                e.target.style.transform = 'translateY(0) scale(1)';
                                e.target.style.boxShadow = '0 4px 15px rgba(255,140,0,0.3), 0 0 0 3px rgba(255,221,9,0.1)';
                                e.target.style.background = 'linear-gradient(135deg, #FFDD09 0%, #FFA500 50%, #FF8C00 100%)';
                            }}
                        >
                            {/* <span style={{ fontSize: '15px', color: '#fff' }}>🔑</span> */}
                            Login
                        </a>
                    </li>
                </ul>

                {/* Mobile Menu Toggle */}
                <div
                    style={{
                        display: 'none',
                        width: '28px',
                        height: '20px',
                        position: 'relative',
                        cursor: 'pointer',
                        flexShrink: 0
                    }}
                    className="mobile-toggle"
                    onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                >
                    <span style={{
                        display: 'block',
                        width: '100%',
                        height: '2px',
                        background: '#C9262C',
                        position: 'absolute',
                        top: isMobileMenuOpen ? '50%' : '0',
                        transform: isMobileMenuOpen ? 'rotate(45deg)' : 'none',
                        transition: 'all 0.3s ease'
                    }} />
                    <span style={{
                        display: 'block',
                        width: '100%',
                        height: '2px',
                        background: '#C9262C',
                        position: 'absolute',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        opacity: isMobileMenuOpen ? 0 : 1,
                        transition: 'all 0.3s ease'
                    }} />
                    <span style={{
                        display: 'block',
                        width: '100%',
                        height: '2px',
                        background: '#C9262C',
                        position: 'absolute',
                        bottom: isMobileMenuOpen ? '50%' : '0',
                        transform: isMobileMenuOpen ? 'rotate(-45deg)' : 'none',
                        transition: 'all 0.3s ease'
                    }} />
                </div>
            </nav>

            {/* Mobile Menu */}
            <div style={{
                display: isMobileMenuOpen ? 'block' : 'none',
                position: 'fixed',
                top: '60px',
                left: 0,
                right: 0,
                bottom: 0,
                background: 'rgba(255, 255, 255, 0.98)',
                backdropFilter: 'blur(20px)',
                padding: '20px',
                overflowY: 'auto',
                zIndex: 999
            }}>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                    {[
                        { label: '🏠 Home', action: () => { window.scrollTo({ top: 0, behavior: 'smooth' }); setIsMobileMenuOpen(false); } },
                        { label: 'ℹ️ About Us', ref: refs.aboutRef },
                        { label: '⚡ Services', ref: refs.servicesRef },
                        { label: '📲 Download App', ref: refs.downloadRef },
                        { label: '🤝 Join Us', ref: refs.joinRef },
                        { label: '📞 Contact Us', ref: refs.contactRef }
                    ].map((item, i) => (
                        <li key={i} style={{ marginBottom: '4px' }}>
                            <a
                                href={`#${item.label.toLowerCase()}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (item.action) item.action();
                                    else handleLinkClick(e, item.ref);
                                }}
                                style={{
                                    display: 'block',
                                    padding: '14px 20px',
                                    color: '#4A4A6A',
                                    textDecoration: 'none',
                                    borderRadius: '12px',
                                    fontSize: '16px',
                                    fontWeight: 500,
                                    transition: 'all 0.3s ease'
                                }}
                                onMouseOver={(e) => { e.target.style.background = '#FFF5F5'; e.target.style.color = '#C9262C'; }}
                                onMouseOut={(e) => { e.target.style.background = 'transparent'; e.target.style.color = '#4A4A6A'; }}
                            >
                                {item.label}
                            </a>
                        </li>
                    ))}
                    <li style={{ marginTop: '12px' }}>
                        <a
                            href="/login"
                            target="_blank"
                            style={{
                                display: 'block',
                                padding: '14px 20px',
                                background: 'linear-gradient(135deg, #FFDD09, #FF8C00)',
                                color: '#1A1A2E',
                                textDecoration: 'none',
                                borderRadius: '12px',
                                fontSize: '16px',
                                fontWeight: 700,
                                textAlign: 'center'
                            }}
                        >
                            🔑 Login
                        </a>
                    </li>
                </ul>
            </div>

            {/* Responsive Styles */}
            <style>{`
                @media (max-width: 991px) {
                    .desktop-nav { display: none !important; }
                    .mobile-toggle { display: block !important; }
                }
                @media (min-width: 992px) {
                    .mobile-toggle { display: none !important; }
                }
            `}</style>
        </header>
    );
}

export default Header;